import React from "react";

const Analysis = () => {
  return <></>;
};

export default Analysis;
